import React from 'react';

const Map = () => {
  return (
    <div className="rounded-xl overflow-hidden border-spacing-1">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.5748237915327!2d90.41697187589655!3d23.72687278967821!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b95e072bd78f%3A0x4d3c8718b86b0bb6!2sIman%20Hasan%2C%20Chartered%20Accountants!5e0!3m2!1sen!2sbd!4v1724169621793!5m2!1sen!2sbd"
        width="100%"
        height="350"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Iman Hasan, Chartered Accountants"
      ></iframe>
    </div>
  );
};

export default Map;
